export const GET_CITIES = "GET_CITIES";
export const GET_LIST_CITIES = "GET_LIST_CITIES";
export const GET_CITY = "GET_CITY";
export const SET_CITIES = "SET_CITIES";
export const SET_LIST_CITIES = "SET_LIST_CITIES";
export const SET_CITY = "SET_CITY";
export const ADD_CITY = "ADD_CITY";
export const SET_NEW_CITY = "SET_NEW_CITY";
export const EDIT_CITY = "EDIT_CITY";
export const SET_EDIT_CITY = "SET_EDIT_CITY";
export const SET_DELETE_CITY = "SET_DELETE_CITY";
export const SET_DELETE_MULTI_CITY = "SET_DELETE_MULTI_CITY";
export const DELETE_CITY = "DELETE_CITY";
export const DELETE_MULTI_CITY = "DELETE_MULTI_CITY";
export const RESET_ITEMS_CITY = "RESET_ITEMS_CITY";
export const RESET_SELECTED_CITY = "RESET_SELECTED_CITY";
export const RESET_LIST_CITIES = "RESET_LIST_CITIES";
